<div class="bg-tertiary upgrade-card mb-4 mb-lg-0">
  <div class="upgrade-section container">
    <div class="row">
      <div class="col-12 col-lg-4 p-0 upgrade-img-container order-lg-1">
        <img
          [src]="'banner-images/membership-stadium-banner.jpg' | contentAssetImage"
          alt="membership upgrade image"
          class="w-100"
        />
      </div>
      <div class="col-lg-8 col-12 upgrade-content-container">
        <div class="d-flex upgrade-description">
          <h5>{{ 'upgrade.membership.title' | translate }}</h5>
          <div class="upgrade-description-text text-white font-size-14 me-lg-2">
            {{ 'upgrade.membership.description' | translate }}
          </div>
        </div>
        <a href="{{ 'upgrade.button.url' | translate }}" target="_blank" class="btn btn-primary text-white fw-bold">
          {{ 'upgrade.membership.button.upgrade' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
